module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aoeAs"))).then(() => parcelRequire('hEqeo'));